import {useRef, useState} from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import {useTranslation} from "react-i18next";
import {SaveChangesRef} from "../common/SaveChangesRef";
import {SettingsLevel} from "../settings/SettingsUtils";
import {DLPSelection} from "./DLPSelection";

export const DLPSystemSelection = () => {
    /**
     * A reference to a component with a saveSettings method which is used to save changes when the save button is clicked
     */
    const saveChangesRef = useRef<SaveChangesRef>();
    /**
     * If set, settings should be saved
     */
    const [shouldSave, setShouldSave] = useState<boolean>(false);
    /**
     * Set to true while saving to show a spinner on the download button
     */
    const [saving, setSaving] = useState<boolean>(false);

    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    return (
        <>
            <DLPSelection settingsLevel={SettingsLevel.System}
                          settingsLevelSubSelector=""
                          setShouldSave={setShouldSave}
                          ref={saveChangesRef}
                          setSaving={setSaving}/>

            <Row>
                <div className="col pt-3 pb-3 border-top">
                    <Button variant="success"
                            type="submit"
                            onClick={() => saveChangesRef.current?.saveChanges()}
                            disabled={!shouldSave}>
                        {saving && <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            aria-hidden="true"
                            className="me-1"
                        />}
                        {saving ? t("common.saving") : t("common.save")}
                    </Button>
                </div>
            </Row>
        </>
    )
}
